export const EXPENSE_LIST_REQUEST  = 'EXPENSE_LIST_REQUEST';
export const EXPENSE_LIST_SUCCESS  = 'EXPENSE_LIST_SUCCESS';
export const EXPENSE_LIST_FAIL     = 'EXPENSE_LIST_FAIL';